import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        groupModel: '=',
        groupList: '=',
        metaFieldLists: '=',
        update: '&',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'general.Manage translations' | translate }}</h2>
        </div>
        <div class="modal-body form translation">
            <form-wrapper form="vm.form">
                <table class="data01">
                    <tr>
                        <th>{{ 'general.Label ' | translate }}</th>
                        <th>{{ vm.defaultLanguage }} <small>({{ 'translation.default' | translate}})</small></th>
                        <th ng-repeat="(code, value) in vm.languages" ng-class="{'active': value}" ng-if="code!==vm.defaultLanguage">
                            <label><input type="checkbox" ng-model="vm.languages[code]"
                            ng-click="vm.toggleCheckbox(code)"> {{ code }}</label>
                        </th>
                    </tr>
                    <tr class="separated">
                        <td>{{ 'translation.Meta group name' | translate }} *</td>
                        <td class="input active">
                            <form-row-wide error="vm.groupForm.errors.metaGroupI18ns[vm.defaultLanguage].name">
                                <div class="items">
                                    <input ng-model="vm.groupForm.model.metaGroupI18ns[vm.defaultLanguage].name" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-class="{'active': value}" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="vm.groupForm.errors.metaGroupI18ns[code].name">
                                <div class="items">
                                    <input ng-model="vm.groupForm.model.metaGroupI18ns[code].name" ng-if="value" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr ng-repeat-start="metaFieldForm in vm.metaFieldForms" class="separated">
                        <td>{{ 'translation.Meta label name' | translate }} *</td>
                        <td class="input">
                            <form-row-wide error="metaFieldForm.errors.metaFieldI18ns[vm.defaultLanguage].name">
                                <div class="items">
                                    <input ng-model="metaFieldForm.model.metaFieldI18ns[vm.defaultLanguage].name" type="text" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-class="{'active': value}" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="metaFieldForm.errors.metaFieldI18ns[code].name">
                                <div class="items">
                                    <input ng-model="metaFieldForm.model.metaFieldI18ns[code].name" ng-if="value" type="text" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr
                        ng-if="metaFieldForm.model.type == vm.FORMS_META_FIELD_TYPE_ENUM.KEYS.SELECT"
                        ng-repeat-start="(key, meta) in metaFieldForm.model.metaFieldValueCount"
                        class="separated"
                    >
                        <td>{{ 'translation.Meta field option' | translate }} *</td>
                        <td class="input">
                            <form-row-wide error="metaFieldForm.errors.metaFieldValuesI18ns[vm.defaultLanguage]">
                                <div class="items">
                                    <input ng-model="metaFieldForm.model.metaFieldValuesI18ns[vm.defaultLanguage][$index].value" type="text" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-class="{'active': value}" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="metaFieldForm.errors.metaFieldValuesI18ns[code]">
                                <div class="items">
                                    <input ng-model="metaFieldForm.model.metaFieldValuesI18ns[code][key].value" ng-if="value" type="text" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr ng-repeat-end></tr>
                    <tr ng-repeat-end></tr>
                </table>
            </form-wrapper>
        </div>
        <div class="modal-footer">
        <ul class="actions01">
            <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
            <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
        </ul>
        </div>
    `
})
export default class {
    constructor ($scope, $translate, lodash, COMPANY_LANGUAGE_ENUM, FORMS_META_FIELD_TYPE_ENUM, TokenService, ModalService, FormFactory) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.FORMS_META_FIELD_TYPE_ENUM = FORMS_META_FIELD_TYPE_ENUM;

        this.groupForm = FormFactory.create(this.groupModel, model => model.$update({
            id: model.id,
            expand: 'activeI18n,metaGroupI18ns'
        }));
    }

    $onInit () {
        this.defaultLanguage = this.TokenService.getCompanyLanguage();

        this.createMetaFieldForm();

        this.manageLanguages();
    }

    createMetaFieldForm () {
        this.metaFieldForms = [];

        this.metaFieldListsCopy = angular.copy(this.metaFieldLists);

        this.lodash.forEach(this.metaFieldListsCopy.items, (metaField) => {
            if (!metaField.metaFieldValuesI18ns || metaField.metaFieldValuesI18ns.length === 0) {
                metaField.metaFieldValuesI18ns = {};
                metaField.metaFieldValuesI18ns[this.defaultLanguage] = [
                    { value: null }
                ];
                metaField.metaFieldValueCount = {};
            }
            else {
                metaField.metaFieldValueCount = this.lodash.filter(metaField.metaFieldValuesI18ns, (metaFieldValue) => {
                    return metaFieldValue.language === this.defaultLanguage;
                });

                metaField.metaFieldValuesI18ns = this.lodash.reduce(metaField.metaFieldValuesI18ns, (origin, item) => {
                    if (!origin[item.language]) {
                        origin[item.language] = [];
                    }
                    origin[item.language].push(item);
                    return origin;
                }, {});
            }

            this.metaFieldForms.push(this.FormFactory.create(metaField, model => model.$update({
                id: model.id,
                expand: 'metaFieldValues,activeI18n,metaFieldI18ns,metaFieldValuesI18ns'
            })));
        });
    }

    manageLanguages () {
        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        // this holds all available language codes as key and whether they are activated as value
        this.languages = {};

        // Find all languages for group only as we can not create a new translation without group
        this.lodash.forEach(this.COMPANY_LANGUAGE_ENUM.KEYS, (code) => {
            this.languages[code] = this.lodash.has(this.groupModel.metaGroupI18ns, code);
            // Find all languages for metaFields
            this.lodash.forEach(this.metaFieldListsCopy.items, (metaField) => {
                if (metaField.metaFieldI18ns[code]) {
                    this.languages[code] = true;
                }
            });
        });
    }

    toggleCheckbox (code) {
        const confirmMessage = this.$translate.instant('translations.Are you sure you would like to remove this translation?');

        if (!this.languages[code]) {
            // leave checkbox checked
            this.languages[code] = !this.languages[code];
            this.ModalService.confirm(confirmMessage, 'medium')
                .then(() => {
                    // uncheck if confirmed
                    this.languages[code] = !this.languages[code];
                    // if language is disabled, make sure no error messages are left in ui
                    if (this.lodash.has(this.groupForm.errors.metaGroupI18ns, code)) {
                        delete this.groupForm.errors.metaGroupI18ns[code];
                    }
                    this.lodash.forEach(this.metaFieldForms, (metaFieldForm, formKey) => {
                        if (metaFieldForm.model.metaFieldI18ns[code]) {
                            delete this.metaFieldForms[formKey].model.metaFieldI18ns[code];
                        }
                        if (metaFieldForm.model.metaFieldValuesI18ns[this.defaultLanguage]) {
                            if (metaFieldForm.model.metaFieldValuesI18ns[code]) {
                                this.lodash.forEach(metaFieldForm.model.metaFieldValuesI18ns[this.defaultLanguage], () => {
                                    delete this.metaFieldForms[formKey].model.metaFieldValuesI18ns[code];
                                });
                            }
                        }
                    });
                });
        }
        else {
            // if language is enabled and form does not have current i18n, make one
            if (!this.lodash.has(this.groupForm.model.metaGroupI18ns, code)) {
                this.groupForm.model.metaGroupI18ns[code] = {};
            }
            this.lodash.forEach(this.metaFieldForms, (metaFieldForm, formKey) => {
                if (!metaFieldForm.model.metaFieldI18ns[code]) {
                    this.metaFieldForms[formKey].model.metaFieldI18ns[code] = {};
                }
                if (metaFieldForm.model.metaFieldValuesI18ns[this.defaultLanguage]) {
                    if (!metaFieldForm.model.metaFieldValuesI18ns[code]) {
                        this.metaFieldForms[formKey].model.metaFieldValuesI18ns[code] = [];
                        this.lodash.forEach(metaFieldForm.model.metaFieldValuesI18ns[this.defaultLanguage], () => {
                            this.metaFieldForms[formKey].model.metaFieldValuesI18ns[code].push({ value: '' });
                        });
                    }
                }
            });
        }
    }

    deleteDisabledTranslations () {
        this.lodash.forEach(this.languages, (isActive, code) => {
            // if language is not active delete it from form
            if (!isActive && this.lodash.has(this.groupForm.model.metaGroupI18ns, code)) {
                delete this.groupForm.model.metaGroupI18ns[code];
            }
        });
    }

    save () {
        this.deleteDisabledTranslations();

        let pendingFormJobCount = this.metaFieldForms.length;

        this.groupForm.save().then((group) => {
            this.groupForm.model = group;
            if (pendingFormJobCount === 0) {
                this.finish();
            }
            this.lodash.forEach(this.metaFieldForms, (metaFieldForm) => {
                metaFieldForm.save().then(() => {
                    pendingFormJobCount -= 1;
                    if (pendingFormJobCount === 0) {
                        this.finish();
                    }
                });
            });
        });
    }

    finish () {
        this.metaFieldLists.fetch({ metaFieldGroupId: this.groupModel.id, expand: 'metaFieldValues,activeI18n,metaFieldI18ns,metaFieldValuesI18ns' });
        this.groupList.fetch({ expand: 'activeI18n,metaGroupI18ns' });
        this.update();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/forms/meta/translation/index.js